<template>
  <v-toolbar
    v-scroll="onScroll"
    :color="isTransparent ? 'transparent' : 'primary'"
    app :flat="isTransparent">
    <v-avatar color="secondary">
      <v-icon size="24px" color="white">mdi-console-line</v-icon>
    </v-avatar>
    <v-toolbar-title class="headline">
      <span class="font-weight-light">MattBooth</span>
      <span class="font-weight-bold">Dev</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
  </v-toolbar>
</template>

<script>
export default {
  name: 'Toolbar',

  data: () => ({
    isTransparent: true
  }),

  methods: {
    onScroll () {
      this.isTransparent = window.pageYOffset < 200
    }
  }
}
</script>
